<div *ngIf="userInfo">
    <router-outlet></router-outlet>
</div>
